import { DeleteOutlined } from '@ant-design/icons';
import { message, Modal } from 'antd';
import { FC } from 'react';
import styled from 'styled-components';
import { useSearchParams } from 'react-router-dom';
// import baseuri from '../../methods/baseuri';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import {
	getSingleMoneyBook,
	doNotPayUser,
} from '../../methods/redux/reducers/moneyBook';

const DeleteSection = styled.div`
	display: inline-flex;
	margin-left: 8px;

	& .deleteIcon {
		font-size: 20px;
		color: red;
		cursor: pointer;
	}
`;
interface IDeleteMoneyBookUser {
	id: string;
	listId: string;
	setRefresh: Function;
}
const DeleteMoneyBookUser: FC<IDeleteMoneyBookUser> = ({
	id,
	listId,
	setRefresh,
}) => {
	const dispatch = useAppDispatch();
	const [searchParams, setSearchParams] = useSearchParams();
	const { singleMoneyBook } = useAppSelector((store) => store.moneyBook);

	const deleteUserPayment = async () => {
		try {
			const queryData = Object.fromEntries(searchParams.entries());
			if (Object.keys(queryData).length === 0) {
				setSearchParams({
					pageId: '1',
					perPage: String(singleMoneyBook?.pagination?.itemsPerPage),
				});
			}

			const jobData = { listId, status: 'deleted' };

			const res = await dispatch(doNotPayUser(jobData));
			if (res) {
				dispatch(getSingleMoneyBook({ i: id, ...queryData }));
				setRefresh(Math.random());
			}
		} catch (error) {
			message.error('Failed to delete user');
		}
	};

	const confirm = () => {
		Modal.confirm({
			title: 'Are you sure you want to Remove this User?',
			onOk() {
				deleteUserPayment();
			},
		});
	};
	return (
		<DeleteSection>
			<DeleteOutlined className="deleteIcon" onClick={confirm} />
		</DeleteSection>
	);
};

export default DeleteMoneyBookUser;
